import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';

/**
 * Generated class for the AbonnementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-abonnement',
  templateUrl: 'abonnement.html',
})
export class AbonnementPage {
  products: any;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private platform: Platform,
    private iap: InAppPurchase
    ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AbonnementPage');

    if (this.platform.is("cordova")){
      this.getProducts();
    }
  }

  getProducts(){
    console.log("getProducts")
    this.iap
    .getProducts(['grandesoif_1mois', 'grandesoif_3mois', 'grandesoif_6mois'])
    .then((products) => {
      console.log(products);
      this.products = products;
       //  [{ productId: 'com.yourapp.prod1', 'title': '...', description: '...', price: '...' }, ...]
    })
    .catch((err) => {
      console.log(err);
    });

  }

  buy(id){
    this.iap
    .buy(id)
    .then((data)=> {
      console.log("buy : " + data);
      // {
      //   transactionId: ...
      //   receipt: ...
      //   signature: ...
      // }
    })
    .catch((err)=> {
      console.log(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/abonnement/abonnement.ts